<template>
    <form @submit.prevent="submit()">
        <div :class="{'has-error': errors.name}" class="form-group col-sm-6">
            <label for="id_pages">Trámite:</label>
            <input name="id_pages" type="number" id="id_pages" class="form-control" v-model="data.id_pages" v-on:change="changeTitle" />
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>
        <div :class="{'has-error': errors.name}" class="form-group col-sm-6">
            <label for="name">Nombre:</label>
            <input maxlength="256" name="name" type="text" id="name" class="form-control" :value="data.name" />
            <div class="help-block" v-if="errors.name">
                {{ errors.name }}
            </div>
        </div>
        <div :class="{'has-error': errors.tokenizador}" class="form-group col-sm-6">
            <label for="tokenizador">Cola de videoatención:</label> 
            <select name="tokenizador" v-model="data.tokenizador" class="form-control" id="tokenizador">
                <option value disabled>Eliga una opción</option>
                <option v-for="{ id, tokenizador_name } in this.tokenizadores.queueTokenizadores" :value="id">{{ tokenizador_name}}</option>
            </select>
            <span class="tokenizador-helper">* Indica a cuál cola de videoatención será derivado el trámite.</span>
            <div class="help-block" v-if="errors.tokenizador">
                {{ errors.tokenizador }}
            </div>
        </div>
        <div class="form-group col-sm-6">
            <label for="claveunica">Clave Única:</label> 
            <label class="checkbox-inline">
                <input name="claveunica" type="checkbox" value="1" id="claveunica"  v-model="data.claveunica" />
            </label>
        </div>
        <div class="form-group col-sm-6">
            <label for="incluir_video_atencion">Incluir en la ficha:</label> 
            <label class="checkbox-inline">
                <input name="incluir_video_atencion" type="checkbox" id="incluir_video_atencion" v-model="data.incluir_video_atencion" />
            </label>
        </div>
        <div class="form-group col-sm-12">
            <input type="submit" value="Guardar" class="btn btn-primary"> 
            <a href="/backend/tramites-sucursal-virtual" class="btn btn-default">Cancelar</a>
        </div>
    </form>
</template>

<style lang="scss" scoped>
    .tokenizador-helper {
        font-size: 14px; 
        font-style: oblique;  
    }
</style>
<script>
import Vue from 'vue';

export default {
    name: "FormAddTramiteSucursalVirtual",
    props: ['tokenizadores'],
    data() {
        return {
            errors: {},
            data: {
                "id_pages": "",
                "name": "",
                "tokenizador": "",
                "claveunica": false,
                "incluir_video_atencion": 1
            },
        }
    },
    mounted() {
    },
    created() {
        const { queueTokenizadores } = this.tokenizadores
        const [ tokens ] = queueTokenizadores
        console.log(tokens)
        // console.log(this.tokenizadores)
        
    },
    methods: {
        changeTitle: function() {
            axios.get('/backend/tramites-sucursal-virtual/getdata/' + this.data.id_pages)
                .then((response) => {
                    if (response.status == 200) {
                        if (response.data.page) {
                            this.data.name = response.data.page;
                        } else {
                            this.data.name = "";
                            alert("Trámite no existe.");
                        }
                    } else {
                        alert("Trámite no existe.");
                    }
                });
        },
        submit: function() {
            this.errors = {};
            // si campo tramite es vacio
            if(typeof(this.data.id_pages) == undefined || this.data.id_pages == '' || this.data.id_pages == null) {
                this.errors.id_pages = "El campo Tramite es requerido";
            } else {
                this.errors.id_pages = false;
            }

            // si campo nombre es vacío
            if(typeof(this.data.name) == undefined || this.data.name == '' || this.data.name == null) {
                this.errors.name = "El campo Nombre es requerido";
            } else {
                this.errors.name = false;
            }
            // si campo tipo tokenizador esta vacío
            if(typeof(this.data.tokenizador) == undefined || this.data.tokenizador == '' || this.data.tokenizador == null) {
                this.errors.tokenizador = "El campo Tokenizador es requerido";
            } else {
                this.errors.tokenizador = false;
            }

            if(typeof(this.data.claveunica) == undefined || this.data.claveunica == '' || this.data.claveunica == null) {
                this.data.claveunica = 0;
            }

            let incluir_video_atencion = document.getElementById("incluir_video_atencion").checked;
            (incluir_video_atencion == true) ? this.data.incluir_video_atencion = 1 : this.data.incluir_video_atencion = 0 ;
      
            if (!this.errors.name && !this.errors.id_pages) {
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
                let params = new FormData();
                params.append('id_pages', this.data.id_pages);
                params.append('name', this.data.name);
                params.append('tokenizador', this.data.tokenizador);
                params.append('claveunica', this.data.claveunica);
                params.append('incluir_video_atencion', this.data.incluir_video_atencion);
                axios.post('/backend/tramites-sucursal-virtual', params, config)
                    .then((response) => {
                        // console.log(response)
                        if (response.status == 200) {
                            if (response.data.code == "ok") {
                                window.location.replace(response.data.redirect);
                            }else{
                                window.location.replace(response.data.redirect);
                            }                            
                        } else {
                            alert("Hubo un error al intentar guardar trámite.");
                        }
                    });
            }
        },
    },
}
</script>
